import { useMutation, useQueryClient } from '@tanstack/react-query'

import { PipelineJobSubmissionPromptTrigger } from '@sparkai/shared-types'

import { apiClient } from '../../apiClient'
import { PIPELINE_QUERY_KEY } from './useGetPipeline'

type PipelineSettingsPayload = {
  isSubmissionPromptEnabled: boolean
  submissionPromptTrigger?: PipelineJobSubmissionPromptTrigger
  submissionDelay: number
  submissionPrompt: string | null
  allowEscalation: boolean
  escalationText: string | null
  hidePredictionLabel: boolean
  autoZoomOnPredictions: boolean
  enableImageShade: boolean
  isRequiredToViewAllMedia: boolean
  isGIFAutoplayEnabled: boolean
  gifAutoplayCount?: number
  escalationOptions: {
    enabled: boolean
    options: {
      escalation: string
      considerResponse: boolean
    }[]
  }
}

export const useEditSettings = (programId: string, jobId: string) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (payload: PipelineSettingsPayload) => {
      const { data } = await apiClient.put(`/int/v3/programs/${programId}/pipeline/jobs/${jobId}/settings`, {
        // TODO: remove deprecated field noChangePrompt FE & BE
        noChangePrompt: '',
        ...payload,
      })
      return data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [PIPELINE_QUERY_KEY] })
    },
  })
}
